export default __webpack_public_path__ + "static/Faith-b275417268eeccc4788b7dcbd53de9f9.png";